import React from 'react';
import { CTA, CTAProps } from '@vw-marketing/us-components';
import { styled, useTheme, css } from '@vw-marketing/us-components';
import {
  applyCustomStylesToChildren,
  separateNestedSelectors,
  applyNestedSelectors,
} from '../Box/utils';

type CTAButtonProps = CTAProps & {
  style?: React.CSSProperties | Record<string, any>;
  className?: string;
  appearance?: string;
  [key: string]: any;
};

export const StyledWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$customStyles',
})<{ $customStyles?: React.CSSProperties | Record<string, any> }>`
  ${({ $customStyles }) => {
    if (!$customStyles || typeof $customStyles !== 'object') return '';

    const { nestedSelectors, regularStyles } =
      separateNestedSelectors($customStyles);

    return css`
      ${applyCustomStylesToChildren(regularStyles as React.CSSProperties)}
      ${applyNestedSelectors(nestedSelectors)}
    `;
  }}
`;

type CustomCTAProps = CTAProps & {
  children?: React.ReactNode;
};
export const CustomCTA = (props: CustomCTAProps) => <CTA {...props} />;

export const CTAButton = React.forwardRef<HTMLDivElement, CTAButtonProps>(
  ({ children, style, ...rest }, ref) => {
    const theme = useTheme();
    const resolvedStyle = typeof style === 'function' ? style(theme) : style;

    const tag = rest.tag || 'button';
    const wrapper =
      tag === 'a' || tag === 'span' || tag === 'sup' ? 'span' : 'div';

    return (
      <StyledWrapper as={wrapper} ref={ref} $customStyles={resolvedStyle}>
        <CustomCTA {...rest} tag={tag}>
          {children}
        </CustomCTA>
      </StyledWrapper>
    );
  }
);

CTAButton.displayName = 'CTAButton';
